import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { Lock, ShieldCheck } from 'lucide-react';

const ForcePasswordChange = () => {
  const { changePassword, logout } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError('La nueva contraseña debe tener al menos 8 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      const result = await changePassword(currentPassword, newPassword);
      if (!result.success) {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message || 'Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '12px 12px 12px 40px',
    background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '8px', color: '#fff', fontSize: '14px',
    outline: 'none', boxSizing: 'border-box'
  };

  return (
    <div data-testid="force-password-change" style={{
      minHeight: 'calc(100vh - 200px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '40px 20px'
    }}>
      <div style={{
        width: '100%', maxWidth: '440px',
        background: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(20px)',
        borderRadius: '16px', border: '1px solid rgba(255,255,255,0.1)',
        padding: '40px 32px', boxShadow: '0 25px 50px rgba(0,0,0,0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{
            width: '56px', height: '56px', borderRadius: '14px',
            background: 'linear-gradient(135deg, #f39c12, #e67e22)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px'
          }}>
            <ShieldCheck size={28} color="white" />
          </div>
          <h1 style={{ color: '#fff', fontSize: '22px', margin: '0 0 8px', fontWeight: 700 }}>
            Cambio de Contraseña Requerido
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
            Por seguridad, debes cambiar tu contraseña antes de continuar.
          </p>
        </div>

        {error && (
          <div data-testid="password-change-error" style={{
            background: 'rgba(233,69,96,0.15)', border: '1px solid rgba(233,69,96,0.3)',
            borderRadius: '8px', padding: '12px', marginBottom: '20px',
            color: '#e94560', fontSize: '14px', textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px', display: 'block', marginBottom: '6px' }}>
              Contraseña actual
            </label>
            <div style={{ position: 'relative' }}>
              <Lock size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.3)' }} />
              <input data-testid="current-password-input" type="password" value={currentPassword}
                onChange={e => setCurrentPassword(e.target.value)} required
                placeholder="Contraseña actual" style={inputStyle} />
            </div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px', display: 'block', marginBottom: '6px' }}>
              Nueva contraseña (mínimo 8 caracteres)
            </label>
            <div style={{ position: 'relative' }}>
              <Lock size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.3)' }} />
              <input data-testid="new-password-input" type="password" value={newPassword}
                onChange={e => setNewPassword(e.target.value)} required minLength={8}
                placeholder="Nueva contraseña" style={inputStyle} />
            </div>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px', display: 'block', marginBottom: '6px' }}>
              Confirmar nueva contraseña
            </label>
            <div style={{ position: 'relative' }}>
              <Lock size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.3)' }} />
              <input data-testid="confirm-password-input" type="password" value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)} required minLength={8}
                placeholder="Confirmar contraseña" style={inputStyle} />
            </div>
          </div>

          <button data-testid="change-password-submit" type="submit" disabled={loading}
            style={{
              width: '100%', padding: '14px',
              background: loading ? 'rgba(243,156,18,0.5)' : 'linear-gradient(135deg, #f39c12, #e67e22)',
              border: 'none', borderRadius: '8px', color: '#fff',
              fontSize: '15px', fontWeight: 600, cursor: loading ? 'wait' : 'pointer'
            }}
          >
            {loading ? 'Cambiando...' : 'Cambiar Contraseña'}
          </button>

          <button type="button" onClick={logout}
            style={{
              width: '100%', padding: '12px', marginTop: '12px',
              background: 'transparent', border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: '8px', color: 'rgba(255,255,255,0.5)',
              fontSize: '14px', cursor: 'pointer'
            }}
          >
            Cerrar Sesión
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
